
import { Component, ActionButtonConfig, FormModalMixins} from "@/lib";
import Role from "@/store/modules/system/role/entity";
@Component
export default class CreateRole extends FormModalMixins {
  model = new Role();
  created(){
      Object.assign(this.config, {modelTitleL: "Action.Add",labelWidth:100, okAction:"system/role/create" });
  }
}
